import { render, staticRenderFns } from "./ProfileGeneralInfo.vue?vue&type=template&id=5df0d7ea&"
import script from "./ProfileGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./ProfileGeneralInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports